module.exports = __webpack_public_path__ + "static/media/bollettini.e04bef7c.svg";